import { gql } from 'react-apollo';

export const getPopularLocation = gql`
    query getPopularLocation {
        getPopularLocation{
        id
        location
        locationAddress
        image
        isEnable
        createdAt
        updatedAt
        }
    }
    `;

export const deletePopularLocationMutation = gql`
    mutation deletePopularLocation ($id: Int!) {
      deletePopularLocation (id: $id) {
          status
        }
      }
    `;

export const updatePopularLocationStatusMutation = gql`
    mutation updatePopularLocationStatus ($id: Int, $isEnable: String){
      updatePopularLocationStatus(id: $id, isEnable: $isEnable){
            status
        }
    }
    `;

export const getStaticInfo = gql`
    {
      getStaticInfo {
          id
          title
          name
          value
          value_en
          value_fr
          value_it
          value_pt
        }
    }
    `;

export const updateFindYourBlock = gql`
    mutation updateFindYourBlock(
        $heading: String,
        $heading_en: String,
        $heading_fr: String,
        $heading_it: String,
        $heading_pt: String,
        $buttonLabel: String,
        $buttonLabel_en: String,
        $buttonLabel_fr: String,
        $buttonLabel_it: String,
        $buttonLabel_pt: String,
        $buttonLink: String,
        $content1: String,
        $content1_en: String,
        $content1_fr: String,
        $content1_it: String,
        $content1_pt: String,
        $content2: String,
        $content2_en: String,
        $content2_fr: String,
        $content2_it: String,
        $content2_pt: String,
        $content3: String,
        $content3_en: String,
        $content3_fr: String,
        $content3_it: String,
        $content3_pt: String,
        $content4: String,
        $content4_en: String,
        $content4_fr: String,
        $content4_it: String,
        $content4_pt: String,
        $content5: String,
        $content5_en: String,
        $content5_fr: String,
        $content5_it: String,
        $content5_pt: String,
        $image: String,
        $isEnabled: Boolean
        ){
            updateFindYourBlock(
            heading: $heading,
            heading_en: $heading_en,
            heading_fr: $heading_fr,
            heading_it: $heading_it,
            heading_pt: $heading_pt,
            buttonLabel: $buttonLabel,
            buttonLabel_en: $buttonLabel_en,
            buttonLabel_fr: $buttonLabel_fr,
            buttonLabel_it: $buttonLabel_it,
            buttonLabel_pt: $buttonLabel_pt,
            buttonLink: $buttonLink,
            content1: $content1,
            content1_en: $content1_en,
            content1_fr: $content1_fr,
            content1_it: $content1_it,
            content1_pt: $content1_pt,
            content2: $content2,
            content2_en: $content2_en,
            content2_fr: $content2_fr,
            content2_it: $content2_it,
            content2_pt: $content2_pt,
            content3: $content3,
            content3_en: $content3_en,
            content3_fr: $content3_fr,
            content3_it: $content3_it,
            content3_pt: $content3_pt,
            content4: $content4,
            content4_en: $content4_en,
            content4_fr: $content4_fr,
            content4_it: $content4_it,
            content4_pt: $content4_pt,
            content5: $content5,
            content5_en: $content5_en,
            content5_fr: $content5_fr,
            content5_it: $content5_it,
            content5_pt: $content5_pt,
            image: $image,
            isEnabled: $isEnabled
        ) {
            status
        }
    }
    `;

export const getFindYourVehicleBlockQuery = gql`{
    getFindYourVehicleBlock {
        results{
            id
            name
            value
            value_en
            value_fr
            value_it
            value_pt
        }
        status
      }
    }`;

export const getHomeLogo = gql`
    query getHomeLogo{
      getHomeLogo {
        id
        title
        name
        value
        type
      }
    }
    `;

export const uploadHomeLogoMutation = gql`
    mutation uploadHomeLogo($fileName: String) {
      uploadHomeLogo (fileName:$fileName) {
        status
      }
    }
    `;

export const removeHomeLogoMutation = gql`
    mutation removeHomeLogo{
      removeHomeLogo{
        status
      }
    }
    `;

export const getBanner = gql`
    {
        getBanner {
          id
          title
          content
          image
        }
      }
    `;

export const uploadHomeBanner = gql`
    mutation uploadHomeBanner($image: String!, $id: Int!){
        uploadHomeBanner(image: $image, id: $id) {
            status
        }
    }
    `;

export const getImageBanner = gql`
    {
        getImageBanner {
            id
            title
            title_en
            title_fr
            title_it
            title_pt
            description
            description_en
            description_fr
            description_it
            description_pt
            buttonLabel
            buttonLabel_en
            buttonLabel_fr
            buttonLabel_it
            buttonLabel_pt
            image
            buttonLabel2
            buttonLabel2_en
            buttonLabel2_fr
            buttonLabel2_it
            buttonLabel2_pt
            buttonLink1
            buttonLink2
        }
    }
    `;

export const updateImageBannerMutation = gql`
    mutation updateImageBanner(
        $title: String!,
        $title_en: String,
        $title_fr: String,
        $title_it: String,
        $title_pt: String,
        $description: String!,
        $description_en: String,
        $description_fr: String,
        $description_it: String,
        $description_pt: String,
        $buttonLabel: String!,
        $buttonLabel_en: String,
        $buttonLabel_fr: String,
        $buttonLabel_it: String,
        $buttonLabel_pt: String,
        $buttonLabel2: String,
        $buttonLabel2_en: String,
        $buttonLabel2_fr: String,
        $buttonLabel2_it: String,
        $buttonLabel2_pt: String,
        $buttonLink1: String,
        $buttonLink2: String
        ){
        updateImageBanner(
            title: $title,
            title_en: $title_en,
            title_fr: $title_fr,
            title_it: $title_it,
            title_pt: $title_pt,
            description: $description,
            description_en: $description_en,
            description_fr: $description_fr,
            description_it: $description_it,
            description_pt: $description_pt,
            buttonLabel: $buttonLabel,
            buttonLabel_en: $buttonLabel_en,
            buttonLabel_fr: $buttonLabel_fr,
            buttonLabel_it: $buttonLabel_it,
            buttonLabel_pt: $buttonLabel_pt,
            buttonLabel2: $buttonLabel2,
            buttonLabel2_en: $buttonLabel2_en,
            buttonLabel2_fr: $buttonLabel2_fr,
            buttonLabel2_it: $buttonLabel2_it,
            buttonLabel2_pt: $buttonLabel2_pt,
            buttonLink1: $buttonLink1,
            buttonLink2: $buttonLink2
        ) {
            status
        }
    }
    `;

export const uploadImageBannerMutation = gql`
    mutation uploadImageBanner($image: String!){
        uploadImageBanner(image: $image) {
            status
        }
    }
    `;

export const editPopularLocation = gql`
    query editPopularLocation ($id: Int!) {
      editPopularLocation (id: $id) {
          id
          location
          locationAddress
          isEnable
          image
      }
    }
    `;

export const uploadLocationMutation = gql`
    mutation uploadLocation(
      $id: Int,
      $image: String,
    ) {
      uploadLocation(
        id: $id,
        image: $image,
      ) {
          status
      }
    }
    `;

export const removeLocationMutation = gql`
    mutation removeLocation(
      $id: Int!,
      $image: String,
    ) {
      removeLocation(
        id: $id,
        image: $image,
      ) {
          status
      }
    }
    `;